import React, { createContext, useContext, ReactNode } from 'react';
import { ServiceType } from '../routes/seoRoutes';

interface AppContextType {
  service?: ServiceType;
  city?: string;
  isServicePage: boolean;
}

const AppContext = createContext<AppContextType | undefined>(undefined);

interface AppProviderProps {
  children: ReactNode;
  service?: ServiceType;
  city?: string;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children, service, city }) => {
  const isServicePage = Boolean(service && city);

  const value: AppContextType = {
    service,
    city,
    isServicePage
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): AppContextType => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
}; 